import { useQuery } from "@tanstack/react-query";
import { getTabs } from "apis/site";
import QUERY_KEYS from "config/queryKey";

export const useTabsQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.tabs],
    queryFn: getTabs,
  });
};
